import { DatePipe } from '@angular/common';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { BodyInactividadCotizador } from 'src/app/interfaces/body_inactividad_cotizador';
import { BodyInactividadDuracion } from 'src/app/interfaces/body_inactividad_duracion';
import { BodyInactividadEspecial } from 'src/app/interfaces/body_inactividad_especial';
import { BodyInactividadInmueble } from 'src/app/interfaces/body_inactividad_inmueble';
import { BodyInactividadInquilino } from 'src/app/interfaces/body_inactividad_inquilino';
import { BodyInactividadPropietario } from 'src/app/interfaces/body_inactividad_propietario';
import { BodyInactividad } from 'src/app/interfaces/bodyInactividad';
import { ResponseServices } from 'src/app/interfaces/response-services';
import { ClienteModel } from 'src/app/models/cliente';
import { DatosGeneralesModel } from 'src/app/models/datosGenenrales';
import { OrquestadorService } from 'src/app/services/orquestador/orquestador.service';
import { environment } from 'src/environments/environment';
import { FEEDBACK, COTIZACION_PAUSA, INFO_ARRENDAMIENTOS, DURACION_CONTRATO, PLANES_SEGUROS, DATOS_PROPIETARIO, INMUEBLE, DATOS_INQUILINO, HOME } from 'src/app/routes.constants';

@Component({
    selector: 'app-tiempo-inactivo',
    standalone: false,
    templateUrl: './tiempo-inactivo.component.html',
    styleUrl: './tiempo-inactivo.component.scss',
})

export class TiempoInactivoComponent implements OnInit, OnDestroy {
    title = 'TiempoInactivoComponent';

    json: string = '';
    jsonFinal: string = '';
    datosCliente!: ClienteModel;
    // Tiempo local de renovación 
    localTimer = environment.LOCAL_TIMER;
    // Cuanta las veces que es invocado el servicio de refrescado de token
    countRefresh = 0;
    // Verifica si hay actividad
    isActivity = false;
    // Intervalo para detectar movimiento del cursor
    isMouseMove: any;
    sessionId: string = '';
    checador: any;
    saliendo: boolean = false;
    dataEnvio: BodyInactividad = {
        SessionId: '',
        productFamily: '',
        screenPercentage: '',
        leadRequeriment: '',
        asesorCode: '',
        leadId: '',
        isInactivity: false,
        productsConfigurationData: {
            PolicyHolder: {
                LastName: '',
                MobilePhone: '',
                PersonalDataAuthorization: false
            },
            Tenant: {
                DocumentNumber: '',
                DocumentType: ''
            },
            Property: {
                AdministrationValue: 0,
                RentalFee: 0,
                Department: '',
                UseProperty: '',
                CityProperty: '',
                Code: '',
                CityCode: '',

                DepartmentCode: '',
            }
        }
    };

    dataEnvioCotizador: BodyInactividadCotizador = {
        SessionId: '',
        productFamily: '',
        screenPercentage: '',
        leadId: '',
        asesorCode: '',
        bitacoraId: '',
        isInactivity: false,
        leadRequeriment: '',
        productsConfigurationData: {
            PolicyHolder: {
                LastName: '',
                MobilePhone: '',
                PersonalDataAuthorization: false
            },
            Tenant: {
                DocumentNumber: '',
                DocumentType: ''
            },
            Property: {
                AdministrationValue: 0,
                RentalFee: 0,
                Department: '',
                UseProperty: '',
                CityProperty: '',
                Code: '',
                CityCode: '',

                DepartmentCode: '',
            }
        }
    };

    dataEnviDuracion: BodyInactividadDuracion = {
        SessionId: '',
        asesorCode: '',
        bitacoraId: '',
        isInactivity: false,
        leadId: '',
        leadRequeriment: '',
        productFamily: '',
        screenPercentage: '',
        productsConfigurationData: {
            PolicyHolder: {
                LastName: '',
                MobilePhone: '',
                PersonalDataAuthorization: false
            },
            Tenant: {
                DocumentNumber: '',
                DocumentType: ''
            },
            Property: {
                AdministrationValue: 0,
                RentalFee: 0,
                Department: '',
                UseProperty: '',
                CityProperty: '',
                Code: '',
                CityCode: '',

                DepartmentCode: '',
            }
        }
    };

    dataEspecial: BodyInactividadEspecial = {
        SessionId: '',
        productFamily: '',
        leadId: '',
        screenPercentage: '',
        asesorCode: '',
        bitacoraId: '',
        optionalProducts: {
            PRD_CoverageAsistence: false,
            PRD_CoveragePublicServices: false
        },
        productsConfigurationData: {
            ProductCode: '',
            PolicyHolder: {
                LastName: '',
                MobilePhone: '',
                PersonalDataAuthorization: false
            },
            Tenant: {
                DocumentNumber: '',
                DocumentType: ''
            },
            Property: {
                AdministrationValue: 0,
                RentalFee: 0,
                Department: '',
                UseProperty: '',
                ContractStartDate: '',
                TemporaryContracted: '',
                CityProperty: '',
                Code: '',
                CityCode: '',

                DepartmentCode: '',
            }
        }
    };

    datosEnvioInactividaPropietario: BodyInactividadPropietario = {
        SessionId: '',
        productFamily: '',
        screenPercentage: '',
        leadId: '',
        bitacoraId: '',
        asesorCode: '',
        isInactivity: false,
        leadRequeriment: '',
        productsConfigurationData: {
            ProductCode: '',
            PolicyHolder: {
                LastName: '',
                MobilePhone: '',
                PersonalDataAuthorization: false,
                PersonalDataVersion: '',
                PersonalDataLastUpdated: '',
                FirstName: '',
                Mail: '',
                ExpeditionDate: '',
                DocumentNumber: '',
                DocumentType: '',
                CountryOfBirth: '',
                SecondLastName: '',
                SecondName: ''
            },
            Tenant: {
                DocumentType: '',
                DocumentNumber: ''
            },
            Property: {
                TemporaryContracted: '',
                ContractStartDate: '',
                AdministrationValue: 0,
                RentalFee: 0,
                Department: '',
                UseProperty: '',
                CityProperty: '',
                Code: '',
                CityCode: '',

                DepartmentCode: '',


                
            }
        }
    };

    datosEnvioInactividaInmueble: BodyInactividadInmueble = {
        productFamily: '',
        screenPercentage: '',
        leadId: '',
        bitacoraId: '',
        asesorCode: '',
        isInactivity: false,
        leadRequeriment: '',
        productsConfigurationData: {
            ProductCode: '',
            PolicyHolder: {
                LastName: '',
                MobilePhone: '',
                PersonalDataAuthorization: false,
                PersonalDataVersion: '',
                PersonalDataLastUpdated: '',
                FirstName: '',
                Mail: '',
                ExpeditionDate: '',
                DocumentNumber: '',
                DocumentType: '',
                CountryOfBirth: '',
                SecondLastName: '',
                SecondName: ''
            },
            Tenant: {
                DocumentType: '',
                DocumentNumber: ''
            },
            Property: {
                TemporaryContracted: '',
                ContractStartDate: '',
                AdministrationValue: 0,
                RentalFee: 0,
                Department: '',
                UseProperty: '',
                CityProperty: '',
                RealEstateLicensePlate: '',
                PropertyAddress: '',

                
                Code: '',
                CityCode: '',

                DepartmentCode: '',
            }
        }
    };

    datosEnvioInquilino: BodyInactividadInquilino = {
        SessionId: '',
        productFamily: '',
        leadId: '',
        bitacoraId: '',
        screenPercentage: '',
        asesorCode: '',
        isInactivity: false,
        leadRequeriment: '',
        productsConfigurationData: {
            ProductCode: '',
            PolicyHolder: {
                LastName: '',
                MobilePhone: '',
                PersonalDataAuthorization: false,
                PersonalDataVersion: '',
                PersonalDataLastUpdated: '',
                FirstName: '',
                Mail: '',
                ExpeditionDate: '',
                DocumentNumber: '',
                DocumentType: '',
                CountryOfBirth: '',
                SecondLastName: '',
                SecondName: ''
            },
            Tenant: {
                DocumentType: '',
                DocumentNumber: '',
                PersonalDataVersion: '',
                PersonalDataLastUpdated: '',
                PersonalDataAuthorization: false,
                MobilePhone: '',
                Mail: '',
                ExpeditionDate: '',
                CountryOfBirth: '',
                SecondLastName: '',
                LastName: '',
                SecondName: '',
                FirstName: ''
            },
            Property: {
                TemporaryContracted: '',
                ContractStartDate: '',
                AdministrationValue: 0,
                RentalFee: 0,
                Department: '',
                UseProperty: '',
                CityProperty: '',
                RealEstateLicensePlate: '',
                PropertyAddress: ''
            }
        }
    };

    response!: ResponseServices;


    porcPantalla: string = '';
    msnPantalla: string = '';
    leadId: string = '';
    codAsesor: string = '';
    IdBitacora: string = '';
    parametro: string = '';


    @HostListener('document:mousemove', ['$event'])
    onMouseMove(e: MouseEvent) {
        let posicionX, posicionY, nuevaPosicionY, nuevaPosicionX;
        this.isActivity = true;
        nuevaPosicionX = e.clientX;
        nuevaPosicionY = e.clientY;

        if (this.isActivity && (nuevaPosicionX !== posicionX || nuevaPosicionY !== posicionY)) {
            clearTimeout(this.checador);
            this.checador = setTimeout(() => {
                this.isActivity = false;
                this.saliendo = true;
                clearInterval(this.isMouseMove);
                clearTimeout(this.checador);//1800000
                if (this.localTimer + 600000) {
                    this.cotizacionEnPausa();
                    this.router.navigate([FEEDBACK]);
                }
            }, this.localTimer + 600000);
        }

        posicionX = e.clientX;
        posicionY = e.clientY;
    }

    private datosGenerales: DatosGeneralesModel = {
        Cliente: {
            cedulaCliente: '',
            celularCliente: '',
            nombreCliente: '',
            tipoIdentificacion: ''
        },
        InfoArrendamiento: {
            tipoPropiedad: '',
            ubicacion: '',
            valorAdministracion: 0,
            valorArriendo: 0,
            fechaContrato: '',
            duracionContrato: '',
            ServiciosPublicos: false,
            PaquetesAsistencia: false
        },
        Propietario: {
            primerNombre: '',
            segundoNombre: '',
            primerApellido: '',
            segundoApellido: '',
            paisNacimiento: '',
            tipoIdentificacion: '',
            numeroIdentificacion: '',
            fechaExpedicion: '',
            correo: ''
        },
        PlanSeleccionado: {
            plan: '',
            valorPlan: 0
        },
        Inmueble: {
            ciudad: '',
            direccion: '',
            maticula: ''
        },
        Inquilino: {
            primerNombre: '',
            segundoNombre: '',
            primerApellido: '',
            segundoApellido: '',
            numCelular: '',
            correo: '',
            paisNacimento: '',
            fechaNacimento: '',
            tipoidentificacion: '',
            documentoIdentidad: '',
            fechaExpedicion: '',
            ciudad: '',
            direccion: ''
        },
        ResponseRiesgoConsultable: [
            {
                esRiesgo: false,
                tipoValidacion: '',
                mensajeValidacion: '',
                idRegistroValidacion: ''
            }
        ]
    }

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private orquestadorService: OrquestadorService
    ) {
    }

    getLocalStorage(): number {
        return Number(localStorage.getItem('session_id'))
    }

    ngOnInit(): void {
        this.saliendo = false;
        this.sessionId = this.getLocalStorage().toString();

        this.route.paramMap.subscribe((params: ParamMap) => {
            this.porcPantalla = params.getAll('porcPll')[0];
            this.msnPantalla = params.getAll('msnPll')[0];
            this.leadId = params.getAll('idLead')[0];
            this.codAsesor = params.getAll('codigoAsesor')[0];
            const resultado = params.get('infoViaje');

            this.IdBitacora = params.getAll('bitacoraId')[0];
            

            if (resultado !== null) {
                this.json = resultado;
                this.jsonFinal = atob(this.json);
                console.log('resultado' + JSON.stringify(this.jsonFinal));   
                this.datosGenerales = JSON.parse(this.jsonFinal);
                this.parametro = JSON.stringify(this.datosGenerales);
            }
        });

        this.cotizacionEnPausa();
    }

    ngOnDestroy(): void {
        if (this.checador) {
            this.saliendo = true;
            this.isActivity = true;
            clearInterval(this.isMouseMove);
            clearTimeout(this.checador);
        }
    }

    contactarAsesor() {

        this.router.navigate([FEEDBACK]);
    }


    cotizacionEnPausa(): void {
        switch (this.porcPantalla) {
            case '5':

                this.GuardarDataLayer();
                break;
            case '10':


                this.GuardarDataLayerCotizador();
                // TODO REVISAR COMPORTAMIENTO

                break;
            case '15':


                this.GuardarDataLayerDuracion();
                break;
            case '25':

                this.GuardarDataLayerDuracion();
                break;
            case '25.1':

                this.GuardarDataLayerEspacial();
                break;
            case '30':

                this.GuardarDataLeyerPropietario();
                break;
            case '35':

                this.GuardarDataLeyerInmueble();
                break;
            case '40':

                this.GuardarDataLeyerInquilino();
                break;
        }

    }

    regresarPagina() {
        switch (this.porcPantalla) {
            case '5':
                this.router.navigate([HOME], { queryParams: { infoCliente: btoa(this.parametro) } });
                break;
            case '10':
                this.router.navigate([INFO_ARRENDAMIENTOS, { queryParams: { idLead: this.leadId, infoCliente: btoa(this.parametro) } }]);
                break;
            case '15':
                this.router.navigate([DURACION_CONTRATO, { queryParams: { idLead: this.leadId, infoCliente: btoa(this.parametro) } }]);
                break;
            case '25':
                this.router.navigate([PLANES_SEGUROS, { queryParams: { idLead: this.leadId, infoCliente: btoa(this.parametro) } }]);
                break;
            case '30':
                this.router.navigate([DATOS_PROPIETARIO, { queryParams: { idLead: this.leadId, infoCliente: btoa(this.parametro) } }]);
                break;
            case '35':
                this.router.navigate([INMUEBLE, { queryParams: { idLead: this.leadId, infoCliente: btoa(this.parametro) } }]);
                break;
            case '40':
                this.router.navigate([DATOS_INQUILINO, { queryParams: { idLead: this.leadId, infoCliente: btoa(this.parametro) } }]);
                break;
        }
    }

    private GuardarDataLayer() {
        this.dataEnvio.SessionId = this.sessionId;
        this.dataEnvio.leadId = this.leadId == 'undefined' ? "0" : this.leadId;
        this.dataEnvio.productFamily = "Arrendamientos";
        this.dataEnvio.screenPercentage = this.porcPantalla;
        this.dataEnvio.leadRequeriment = this.msnPantalla;

        if (this.codAsesor === 'undefined') {
            this.codAsesor = '';
            this.dataEnvio.asesorCode = this.codAsesor;
        }

        if (this.codAsesor != '') {
            this.dataEnvio.asesorCode = this.codAsesor;
        }
        else {
            this.dataEnvio.asesorCode = this.codAsesor;
        }

        this.dataEnvio.isInactivity = true;
        this.dataEnvio.productsConfigurationData.PolicyHolder.LastName = this.datosGenerales.Cliente.nombreCliente;
        this.dataEnvio.productsConfigurationData.PolicyHolder.MobilePhone = this.datosGenerales.Cliente.celularCliente.toString();
        this.dataEnvio.productsConfigurationData.PolicyHolder.PersonalDataAuthorization = true;
        this.dataEnvio.productsConfigurationData.Tenant.DocumentNumber = this.datosGenerales.Cliente.cedulaCliente.toString();
        this.dataEnvio.productsConfigurationData.Tenant.DocumentType = this.datosGenerales.Cliente.tipoIdentificacion;
        this.dataEnvio.productsConfigurationData.Property.AdministrationValue = this.datosGenerales.InfoArrendamiento.valorAdministracion;
        this.dataEnvio.productsConfigurationData.Property.RentalFee = this.datosGenerales.InfoArrendamiento.valorArriendo;
        this.dataEnvio.productsConfigurationData.Property.Department = this.datosGenerales.InfoArrendamiento.ubicacion;
        this.dataEnvio.productsConfigurationData.Property.UseProperty = this.datosGenerales.InfoArrendamiento.tipoPropiedad;
        this.dataEnvio.productsConfigurationData.Property.Code = this.datosGenerales.InfoArrendamiento.Code;
        this.dataEnvio.productsConfigurationData.Property.CityCode = this.datosGenerales.InfoArrendamiento.CityCode;
        this.dataEnvio.productsConfigurationData.Property.DepartmentCode = this.datosGenerales.InfoArrendamiento.DepartmentCode;
        this.dataEnvio.productsConfigurationData.Property.CityProperty = this.datosGenerales.InfoArrendamiento.CityProperty;


        this.orquestadorService.postOrquestadorEnvioGen(this.dataEnvio).
            subscribe(
                (data) => {
                    this.response = data;
                }
            );
    }

    private GuardarDataLayerCotizador() {
        console.log('GuardarDataLayerCotizador' + JSON.stringify(this.datosGenerales));
        this.dataEnvioCotizador.SessionId = this.sessionId;
        this.dataEnvioCotizador.productFamily = "Arrendamientos";
        this.dataEnvioCotizador.screenPercentage = this.porcPantalla;
        this.dataEnvioCotizador.leadId = this.leadId == 'undefined' ? "" : this.leadId;
        this.dataEnvioCotizador.bitacoraId = this.IdBitacora == 'undefined' ? "" : this.IdBitacora;

        if (this.codAsesor === 'undefined') {
            this.codAsesor = '';
            this.dataEnvioCotizador.asesorCode = this.codAsesor;
        }

        if (this.codAsesor != '') {
            this.dataEnvioCotizador.asesorCode = this.codAsesor;
        }
        else {
            this.dataEnvioCotizador.asesorCode = this.codAsesor;
        }

        this.dataEnvioCotizador.isInactivity = true;
        this.dataEnvioCotizador.leadRequeriment = this.msnPantalla;
        this.dataEnvioCotizador.productsConfigurationData.PolicyHolder.LastName = this.datosGenerales.Cliente.nombreCliente;
        this.dataEnvioCotizador.productsConfigurationData.PolicyHolder.MobilePhone = this.datosGenerales.Cliente.celularCliente.toString();
        this.dataEnvioCotizador.productsConfigurationData.PolicyHolder.PersonalDataAuthorization = true;
        this.dataEnvioCotizador.productsConfigurationData.Tenant.DocumentNumber = this.datosGenerales.Cliente.cedulaCliente.toString();
        this.dataEnvioCotizador.productsConfigurationData.Tenant.DocumentType = this.datosGenerales.Cliente.tipoIdentificacion;
        this.dataEnvioCotizador.productsConfigurationData.Property.AdministrationValue = this.datosGenerales.InfoArrendamiento.valorAdministracion;
        this.dataEnvioCotizador.productsConfigurationData.Property.RentalFee = this.datosGenerales.InfoArrendamiento.valorArriendo;
        this.dataEnvioCotizador.productsConfigurationData.Property.Department = this.datosGenerales.InfoArrendamiento.ubicacion  || this.datosGenerales.InfoArrendamiento.Department || '';
        this.dataEnvioCotizador.productsConfigurationData.Property.UseProperty = this.datosGenerales.InfoArrendamiento.tipoPropiedad ;
        this.dataEnvioCotizador.productsConfigurationData.Property.Code = this.datosGenerales.InfoArrendamiento.Code;
        this.dataEnvioCotizador.productsConfigurationData.Property.CityCode = this.datosGenerales.InfoArrendamiento.CityCode;
        this.dataEnvioCotizador.productsConfigurationData.Property.DepartmentCode = this.datosGenerales.InfoArrendamiento.DepartmentCode;
        this.dataEnvioCotizador.productsConfigurationData.Property.CityProperty = this.datosGenerales.InfoArrendamiento.CityProperty;


        this.orquestadorService.postOrquestadorEnvioGen(this.dataEnvioCotizador).
            subscribe(
                (data) => {
                    this.response = data;
                }
            );
    }

    private GuardarDataLayerDuracion() {
        this.dataEnviDuracion.SessionId = this.sessionId;
        this.dataEnviDuracion.leadId = this.leadId == 'undefined' ? "" : this.leadId;
        this.dataEnviDuracion.productFamily = "Arrendamientos";
        this.dataEnviDuracion.screenPercentage = this.porcPantalla;
        this.dataEnviDuracion.leadRequeriment = this.msnPantalla;

        if (this.codAsesor === 'undefined') {
            this.codAsesor = '';
            this.dataEnviDuracion.asesorCode = this.codAsesor;
        }

        if (this.codAsesor != '') {
            this.dataEnviDuracion.asesorCode = this.codAsesor;
        }
        else {
            this.dataEnviDuracion.asesorCode = this.codAsesor;
        }

        this.dataEnviDuracion.bitacoraId = this.IdBitacora;
        this.dataEnviDuracion.isInactivity = true;
        this.dataEnviDuracion.productsConfigurationData.PolicyHolder.LastName = this.datosGenerales.Cliente.nombreCliente;
        this.dataEnviDuracion.productsConfigurationData.PolicyHolder.MobilePhone = this.datosGenerales.Cliente.celularCliente.toString();
        this.dataEnviDuracion.productsConfigurationData.PolicyHolder.PersonalDataAuthorization = true;
        this.dataEnviDuracion.productsConfigurationData.Tenant.DocumentNumber = this.datosGenerales.Cliente.cedulaCliente.toString();
        this.dataEnviDuracion.productsConfigurationData.Tenant.DocumentType = this.datosGenerales.Cliente.tipoIdentificacion;
        this.dataEnviDuracion.productsConfigurationData.Property.AdministrationValue = this.datosGenerales.InfoArrendamiento.valorAdministracion;
        this.dataEnviDuracion.productsConfigurationData.Property.RentalFee = this.datosGenerales.InfoArrendamiento.valorArriendo;
        this.dataEnviDuracion.productsConfigurationData.Property.Department = this.datosGenerales.InfoArrendamiento.ubicacion;
        this.dataEnviDuracion.productsConfigurationData.Property.UseProperty = this.datosGenerales.InfoArrendamiento.tipoPropiedad;
        this.dataEnviDuracion.productsConfigurationData.Property.Code = this.datosGenerales.InfoArrendamiento.Code;
        this.dataEnviDuracion.productsConfigurationData.Property.CityCode = this.datosGenerales.InfoArrendamiento.CityCode;
        this.dataEnviDuracion.productsConfigurationData.Property.DepartmentCode = this.datosGenerales.InfoArrendamiento.DepartmentCode;
        this.dataEnviDuracion.productsConfigurationData.Property.CityProperty = this.datosGenerales.InfoArrendamiento.CityProperty;


        this.orquestadorService.postOrquestadorEnvioGen(this.dataEnviDuracion).
            subscribe(
                (data) => {
                    this.response = data;
                }
            );
    }

    private GuardarDataLayerEspacial() {
        this.dataEspecial.SessionId = this.sessionId;
        this.dataEspecial.productFamily = 'Arrendamientos';
        this.dataEspecial.leadId = this.leadId == 'undefined' ? "" : this.leadId;
        this.dataEspecial.screenPercentage = '25';

        if (this.codAsesor === 'undefined') {
            this.codAsesor = '';
            this.dataEspecial.asesorCode = this.codAsesor;
        }

        if (this.codAsesor != '') {
            this.dataEspecial.asesorCode = this.codAsesor;
        }
        else {
            this.dataEspecial.asesorCode = this.codAsesor;
        }

        this.dataEspecial.bitacoraId = this.IdBitacora;

        this.dataEspecial.optionalProducts.PRD_CoverageAsistence = true;
        this.dataEspecial.optionalProducts.PRD_CoveragePublicServices = true;

        this.dataEspecial.productsConfigurationData.ProductCode = this.datosGenerales.PlanSeleccionado.plan;

        this.dataEspecial.productsConfigurationData.PolicyHolder.LastName = this.datosGenerales.Cliente.nombreCliente;
        this.dataEspecial.productsConfigurationData.PolicyHolder.MobilePhone = this.datosGenerales.Cliente.celularCliente.toString();
        this.dataEspecial.productsConfigurationData.PolicyHolder.PersonalDataAuthorization = true;
        this.dataEspecial.productsConfigurationData.Tenant.DocumentNumber = this.datosGenerales.Cliente.cedulaCliente.toString();
        this.dataEspecial.productsConfigurationData.Tenant.DocumentType = this.datosGenerales.Cliente.tipoIdentificacion;

        this.dataEspecial.productsConfigurationData.Property.AdministrationValue = this.datosGenerales.InfoArrendamiento.valorAdministracion;
        this.dataEspecial.productsConfigurationData.Property.RentalFee = this.datosGenerales.InfoArrendamiento.valorArriendo;
        this.dataEspecial.productsConfigurationData.Property.Department = this.datosGenerales.InfoArrendamiento.ubicacion;
        this.dataEspecial.productsConfigurationData.Property.UseProperty = this.datosGenerales.InfoArrendamiento.tipoPropiedad;
        this.dataEspecial.productsConfigurationData.Property.ContractStartDate = this.datosGenerales.InfoArrendamiento.fechaContrato;
        this.dataEspecial.productsConfigurationData.Property.TemporaryContracted = this.datosGenerales.InfoArrendamiento.duracionContrato;
        this.dataEspecial.productsConfigurationData.Property.CityProperty = this.datosGenerales.Inmueble.ciudad;
        this.dataEspecial.productsConfigurationData.Property.Code = this.datosGenerales.InfoArrendamiento.Code;
        this.dataEspecial.productsConfigurationData.Property.CityCode = this.datosGenerales.InfoArrendamiento.CityCode;
        this.dataEspecial.productsConfigurationData.Property.DepartmentCode = this.datosGenerales.InfoArrendamiento.DepartmentCode;


        this.orquestadorService.postOrquestadorEnvioGen(this.dataEspecial).
            subscribe(
                (data) => {
                    this.response = data;
                }
            );
    }

    private GuardarDataLeyerPropietario() {
        const datepipe: DatePipe = new DatePipe('en-US')
        let formattedDate = datepipe.transform(Date.now(), 'dd/MM/YYYY');

        this.datosEnvioInactividaPropietario.SessionId = this.sessionId;
        this.datosEnvioInactividaPropietario.productFamily = 'Arrendamientos';
        this.datosEnvioInactividaPropietario.leadId = this.leadId == 'undefined' ? "" : this.leadId;
        this.datosEnvioInactividaPropietario.bitacoraId = this.IdBitacora == 'undefined' ? "" : this.IdBitacora;
        this.datosEnvioInactividaPropietario.isInactivity = true;
        this.datosEnvioInactividaPropietario.leadRequeriment = this.msnPantalla;

        if (this.codAsesor === 'undefined') {
            this.codAsesor = '';
            this.datosEnvioInactividaPropietario.asesorCode = this.codAsesor;
        }

        if (this.codAsesor != '') {
            this.datosEnvioInactividaPropietario.asesorCode = this.codAsesor;
        }
        else {
            this.datosEnvioInactividaPropietario.asesorCode = this.codAsesor;
        }

        this.datosEnvioInactividaPropietario.screenPercentage = this.porcPantalla;

        this.datosEnvioInactividaPropietario.productsConfigurationData.ProductCode = this.datosGenerales.PlanSeleccionado.plan
        this.datosEnvioInactividaPropietario.productsConfigurationData.PolicyHolder.LastName = this.datosGenerales.Propietario.primerApellido;
        this.datosEnvioInactividaPropietario.productsConfigurationData.PolicyHolder.MobilePhone = this.datosGenerales.Cliente.celularCliente.toString();
        this.datosEnvioInactividaPropietario.productsConfigurationData.PolicyHolder.PersonalDataAuthorization = true;
        this.datosEnvioInactividaPropietario.productsConfigurationData.PolicyHolder.PersonalDataVersion = this.datosEnvioInactividaPropietario.productsConfigurationData.PolicyHolder.PersonalDataVersion == '' ? (formattedDate === null ? '' : formattedDate) : this.datosEnvioInactividaPropietario.productsConfigurationData.PolicyHolder.PersonalDataVersion;
        this.datosEnvioInactividaPropietario.productsConfigurationData.PolicyHolder.PersonalDataLastUpdated = formattedDate === null ? '' : formattedDate;
        this.datosEnvioInactividaPropietario.productsConfigurationData.PolicyHolder.FirstName = this.datosGenerales.Propietario.primerNombre;
        this.datosEnvioInactividaPropietario.productsConfigurationData.PolicyHolder.Mail = this.datosGenerales.Propietario.correo;
        this.datosEnvioInactividaPropietario.productsConfigurationData.PolicyHolder.ExpeditionDate = this.datosGenerales.Propietario.fechaExpedicion;
        this.datosEnvioInactividaPropietario.productsConfigurationData.PolicyHolder.DocumentNumber = this.datosGenerales.Propietario.numeroIdentificacion.toString();
        this.datosEnvioInactividaPropietario.productsConfigurationData.PolicyHolder.DocumentType = this.datosGenerales.Propietario.tipoIdentificacion;
        this.datosEnvioInactividaPropietario.productsConfigurationData.PolicyHolder.CountryOfBirth = this.datosGenerales.Propietario.paisNacimiento;
        this.datosEnvioInactividaPropietario.productsConfigurationData.PolicyHolder.SecondLastName = this.datosGenerales.Propietario.segundoApellido;
        this.datosEnvioInactividaPropietario.productsConfigurationData.PolicyHolder.SecondName = this.datosGenerales.Propietario.segundoNombre;
        this.datosEnvioInactividaPropietario.productsConfigurationData.Tenant.DocumentNumber = this.datosGenerales.Cliente.cedulaCliente.toString();
        this.datosEnvioInactividaPropietario.productsConfigurationData.Tenant.DocumentType = this.datosGenerales.Cliente.tipoIdentificacion;
        this.datosEnvioInactividaPropietario.productsConfigurationData.Property.AdministrationValue = this.datosGenerales.InfoArrendamiento.valorAdministracion;
        this.datosEnvioInactividaPropietario.productsConfigurationData.Property.RentalFee = this.datosGenerales.InfoArrendamiento.valorArriendo;
        this.datosEnvioInactividaPropietario.productsConfigurationData.Property.Department = this.datosGenerales.InfoArrendamiento.ubicacion || this.datosGenerales.InfoArrendamiento.Department || '';
        this.datosEnvioInactividaPropietario.productsConfigurationData.Property.UseProperty = this.datosGenerales.InfoArrendamiento.tipoPropiedad;
        this.datosEnvioInactividaPropietario.productsConfigurationData.Property.ContractStartDate = this.datosGenerales.InfoArrendamiento.fechaContrato;
        this.datosEnvioInactividaPropietario.productsConfigurationData.Property.TemporaryContracted = this.datosGenerales.InfoArrendamiento.duracionContrato;
         this.datosEnvioInactividaPropietario.productsConfigurationData.Property.CityProperty = this.datosGenerales.InfoArrendamiento.CityProperty  || '';
         this.datosEnvioInactividaPropietario.productsConfigurationData.Property.Code = this.datosGenerales.InfoArrendamiento.Code;
         this.datosEnvioInactividaPropietario.productsConfigurationData.Property.CityCode = this.datosGenerales.InfoArrendamiento.CityCode;
         this.datosEnvioInactividaPropietario.productsConfigurationData.Property.DepartmentCode = this.datosGenerales.InfoArrendamiento.DepartmentCode;


        


        this.orquestadorService.postOrquestadorEnvioGen(this.datosEnvioInactividaPropietario).
            subscribe(
                (data) => {
                    this.response = data;
                }
            );
    }

    private GuardarDataLeyerInmueble() {
        const datepipe: DatePipe = new DatePipe('en-US')
        let formattedDate = datepipe.transform(Date.now(), 'dd/MM/YYYY');

        this.datosEnvioInactividaInmueble.productFamily = 'Arrendamientos';
        this.datosEnvioInactividaInmueble.leadId = this.leadId == 'undefined' ? "" : this.leadId;
        this.datosEnvioInactividaInmueble.bitacoraId = this.IdBitacora == 'undefined' ? "" : this.IdBitacora;

        if (this.codAsesor === 'undefined') {
            this.codAsesor = '';
            this.datosEnvioInactividaInmueble.asesorCode = this.codAsesor;
        }

        if (this.codAsesor != '') {
            this.datosEnvioInactividaInmueble.asesorCode = this.codAsesor;
        }
        else {
            this.datosEnvioInactividaInmueble.asesorCode = this.codAsesor;
        }

        this.datosEnvioInactividaInmueble.screenPercentage = this.porcPantalla;
        this.datosEnvioInactividaInmueble.isInactivity = true;
        this.datosEnvioInactividaInmueble.leadRequeriment = this.msnPantalla;

        this.datosEnvioInactividaInmueble.productsConfigurationData.ProductCode = this.datosGenerales.PlanSeleccionado.plan
        this.datosEnvioInactividaInmueble.productsConfigurationData.PolicyHolder.LastName = this.datosGenerales.Propietario.primerApellido;
        this.datosEnvioInactividaInmueble.productsConfigurationData.PolicyHolder.MobilePhone = this.datosGenerales.Cliente.celularCliente.toString();
        this.datosEnvioInactividaInmueble.productsConfigurationData.PolicyHolder.PersonalDataAuthorization = true;
        this.datosEnvioInactividaInmueble.productsConfigurationData.PolicyHolder.PersonalDataVersion = this.datosEnvioInactividaPropietario.productsConfigurationData.PolicyHolder.PersonalDataVersion == '' ? (formattedDate === null ? '' : formattedDate) : this.datosEnvioInactividaPropietario.productsConfigurationData.PolicyHolder.PersonalDataVersion;
        this.datosEnvioInactividaInmueble.productsConfigurationData.PolicyHolder.PersonalDataLastUpdated = formattedDate === null ? '' : formattedDate;
        this.datosEnvioInactividaInmueble.productsConfigurationData.PolicyHolder.FirstName = this.datosGenerales.Propietario.primerNombre;
        this.datosEnvioInactividaInmueble.productsConfigurationData.PolicyHolder.Mail = this.datosGenerales.Propietario.correo;
        this.datosEnvioInactividaInmueble.productsConfigurationData.PolicyHolder.ExpeditionDate = this.datosGenerales.Propietario.fechaExpedicion;
        this.datosEnvioInactividaInmueble.productsConfigurationData.PolicyHolder.DocumentNumber = this.datosGenerales.Propietario.numeroIdentificacion.toString();
        this.datosEnvioInactividaInmueble.productsConfigurationData.PolicyHolder.DocumentType = this.datosGenerales.Propietario.tipoIdentificacion;
        this.datosEnvioInactividaInmueble.productsConfigurationData.PolicyHolder.CountryOfBirth = this.datosGenerales.Propietario.paisNacimiento;
        this.datosEnvioInactividaInmueble.productsConfigurationData.PolicyHolder.SecondLastName = this.datosGenerales.Propietario.segundoApellido;
        this.datosEnvioInactividaInmueble.productsConfigurationData.PolicyHolder.SecondName = this.datosGenerales.Propietario.segundoNombre;

        this.datosEnvioInactividaInmueble.productsConfigurationData.Tenant.DocumentNumber = this.datosGenerales.Cliente.cedulaCliente.toString();
        this.datosEnvioInactividaInmueble.productsConfigurationData.Tenant.DocumentType = this.datosGenerales.Cliente.tipoIdentificacion;

        this.datosEnvioInactividaInmueble.productsConfigurationData.Property.AdministrationValue = this.datosGenerales.InfoArrendamiento.valorAdministracion;
        this.datosEnvioInactividaInmueble.productsConfigurationData.Property.RentalFee = this.datosGenerales.InfoArrendamiento.valorArriendo;
        this.datosEnvioInactividaInmueble.productsConfigurationData.Property.Department = this.datosGenerales.InfoArrendamiento.ubicacion;
        this.datosEnvioInactividaInmueble.productsConfigurationData.Property.UseProperty = this.datosGenerales.InfoArrendamiento.tipoPropiedad;
        this.datosEnvioInactividaInmueble.productsConfigurationData.Property.ContractStartDate = this.datosGenerales.InfoArrendamiento.fechaContrato;
        this.datosEnvioInactividaInmueble.productsConfigurationData.Property.CityProperty = this.datosGenerales.Inmueble.ciudad;
        this.datosEnvioInactividaInmueble.productsConfigurationData.Property.RealEstateLicensePlate = this.datosGenerales.Inmueble.maticula;
        this.datosEnvioInactividaInmueble.productsConfigurationData.Property.PropertyAddress = this.datosGenerales.Inmueble.direccion;
        this.datosEnvioInactividaInmueble.productsConfigurationData.Property.TemporaryContracted = this.datosGenerales.InfoArrendamiento.duracionContrato;
        
       
        this.datosEnvioInactividaInmueble.productsConfigurationData.Property.CityProperty = this.datosGenerales.InfoArrendamiento.CityProperty  || '';
        this.datosEnvioInactividaInmueble.productsConfigurationData.Property.Code = this.datosGenerales.InfoArrendamiento.Code;
        this.datosEnvioInactividaInmueble.productsConfigurationData.Property.CityCode = this.datosGenerales.InfoArrendamiento.CityCode;
        this.datosEnvioInactividaInmueble.productsConfigurationData.Property.DepartmentCode = this.datosGenerales.InfoArrendamiento.DepartmentCode;

        
        this.orquestadorService.postOrquestadorEnvioGen(this.datosEnvioInactividaInmueble).
            subscribe(
                (data) => {
                    this.response = data;
                }
            );
    }

    private GuardarDataLeyerInquilino() {
        const datepipe: DatePipe = new DatePipe('en-US')
        let formattedDate = datepipe.transform(Date.now(), 'dd/MM/YYYY');

        this.datosEnvioInquilino.SessionId = this.sessionId;
        this.datosEnvioInquilino.leadId = this.leadId == 'undefined' ? "" : this.leadId;
        this.datosEnvioInquilino.productFamily = 'Arrendamientos';
        this.datosEnvioInquilino.bitacoraId = this.IdBitacora == 'undefined' ? "" : this.IdBitacora;

        if (this.codAsesor === 'undefined') {
            this.codAsesor = '';
            this.datosEnvioInquilino.asesorCode = this.codAsesor;
        }

        if (this.codAsesor != '') {
            this.datosEnvioInquilino.asesorCode = this.codAsesor;
        }
        else {
            this.datosEnvioInquilino.asesorCode = this.codAsesor;
        }

        this.datosEnvioInquilino.screenPercentage = this.porcPantalla;
        this.datosEnvioInquilino.isInactivity = true;
        this.datosEnvioInquilino.leadRequeriment = this.msnPantalla;

        this.datosEnvioInquilino.productsConfigurationData.ProductCode = this.datosGenerales.PlanSeleccionado.plan
        this.datosEnvioInquilino.productsConfigurationData.PolicyHolder.LastName = this.datosGenerales.Propietario.primerApellido;
        this.datosEnvioInquilino.productsConfigurationData.PolicyHolder.MobilePhone = this.datosGenerales.Cliente.celularCliente.toString();
        this.datosEnvioInquilino.productsConfigurationData.PolicyHolder.PersonalDataAuthorization = true;
        this.datosEnvioInquilino.productsConfigurationData.PolicyHolder.PersonalDataVersion = this.datosEnvioInquilino.productsConfigurationData.PolicyHolder.PersonalDataVersion == '' ? (formattedDate === null ? '' : formattedDate) : this.datosEnvioInquilino.productsConfigurationData.PolicyHolder.PersonalDataVersion;
        this.datosEnvioInquilino.productsConfigurationData.PolicyHolder.PersonalDataLastUpdated = formattedDate === null ? '' : formattedDate;
        this.datosEnvioInquilino.productsConfigurationData.PolicyHolder.FirstName = this.datosGenerales.Propietario.primerNombre;
        this.datosEnvioInquilino.productsConfigurationData.PolicyHolder.Mail = this.datosGenerales.Propietario.correo;
        this.datosEnvioInquilino.productsConfigurationData.PolicyHolder.ExpeditionDate = this.datosGenerales.Propietario.fechaExpedicion;
        this.datosEnvioInquilino.productsConfigurationData.PolicyHolder.DocumentNumber = this.datosGenerales.Propietario.numeroIdentificacion.toString();
        this.datosEnvioInquilino.productsConfigurationData.PolicyHolder.DocumentType = this.datosGenerales.Cliente.tipoIdentificacion;
        this.datosEnvioInquilino.productsConfigurationData.PolicyHolder.CountryOfBirth = this.datosGenerales.Propietario.paisNacimiento;
        this.datosEnvioInquilino.productsConfigurationData.PolicyHolder.SecondLastName = this.datosGenerales.Propietario.segundoApellido;
        this.datosEnvioInquilino.productsConfigurationData.PolicyHolder.SecondName = this.datosGenerales.Propietario.segundoNombre;

        this.datosEnvioInquilino.productsConfigurationData.Tenant.DocumentNumber = this.datosGenerales.Cliente.cedulaCliente.toString();
        this.datosEnvioInquilino.productsConfigurationData.Tenant.DocumentType = this.datosGenerales.Inquilino.tipoidentificacion;
        this.datosEnvioInquilino.productsConfigurationData.Tenant.PersonalDataVersion = this.datosEnvioInquilino.productsConfigurationData.Tenant.PersonalDataVersion == '' ? (formattedDate === null ? '' : formattedDate) : this.datosEnvioInquilino.productsConfigurationData.Tenant.PersonalDataVersion;
        this.datosEnvioInquilino.productsConfigurationData.Tenant.PersonalDataLastUpdated = formattedDate === null ? '' : formattedDate;
        this.datosEnvioInquilino.productsConfigurationData.Tenant.PersonalDataAuthorization = true;
        this.datosEnvioInquilino.productsConfigurationData.Tenant.MobilePhone = this.datosGenerales.Inquilino.numCelular;
        this.datosEnvioInquilino.productsConfigurationData.Tenant.Mail = this.datosGenerales.Inquilino.correo;
        this.datosEnvioInquilino.productsConfigurationData.Tenant.ExpeditionDate = this.datosGenerales.Inquilino.fechaExpedicion;
        this.datosEnvioInquilino.productsConfigurationData.Tenant.CountryOfBirth = this.datosGenerales.Inquilino.paisNacimento;
        this.datosEnvioInquilino.productsConfigurationData.Tenant.SecondLastName = this.datosGenerales.Inquilino.segundoApellido;
        this.datosEnvioInquilino.productsConfigurationData.Tenant.LastName = this.datosGenerales.Inquilino.primerApellido;
        this.datosEnvioInquilino.productsConfigurationData.Tenant.SecondName = this.datosGenerales.Inquilino.segundoNombre;
        this.datosEnvioInquilino.productsConfigurationData.Tenant.FirstName = this.datosGenerales.Inquilino.primerNombre;

        this.datosEnvioInquilino.productsConfigurationData.Property.AdministrationValue = this.datosGenerales.InfoArrendamiento.valorAdministracion;
        this.datosEnvioInquilino.productsConfigurationData.Property.RentalFee = this.datosGenerales.InfoArrendamiento.valorArriendo;
        this.datosEnvioInquilino.productsConfigurationData.Property.Department = this.datosGenerales.InfoArrendamiento.ubicacion;
        this.datosEnvioInquilino.productsConfigurationData.Property.UseProperty = this.datosGenerales.InfoArrendamiento.tipoPropiedad;
        this.datosEnvioInquilino.productsConfigurationData.Property.ContractStartDate = this.datosGenerales.InfoArrendamiento.fechaContrato;
        this.datosEnvioInquilino.productsConfigurationData.Property.CityProperty = this.datosGenerales.Inmueble.ciudad;
        this.datosEnvioInquilino.productsConfigurationData.Property.TemporaryContracted = this.datosGenerales.InfoArrendamiento.duracionContrato;
        this.datosEnvioInquilino.productsConfigurationData.Property.RealEstateLicensePlate = this.datosGenerales.Inmueble.maticula;
        this.datosEnvioInquilino.productsConfigurationData.Property.PropertyAddress = this.datosGenerales.Inmueble.direccion;

        this.orquestadorService.postOrquestadorEnvioGen(this.datosEnvioInquilino).
            subscribe(
                (data) => {
                    const response = data;
                }
            );
    }

}
